import FinanceSettlementRequest from '@/models/finance/FinanceSettlementRequest';
import FinanceSettlementResponse from '@/models/finance/FinanceSettlementResult';

class SettlementCalculatorService {
  private static serviceInstance: SettlementCalculatorService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  private apiDomain: string = `${
    process.env.VUE_APP_API_PRICING
  }/api/v1/finance/settlement`;

  public getFinanceSettlement(financeSettlementRequest: FinanceSettlementRequest): Promise<FinanceSettlementResponse> {
    return fetch(`${this.apiDomain}`, {
      body: JSON.stringify(financeSettlementRequest),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(response.statusText);
      })
      .catch((error) => {
        console.log('There was an issue calling the Pricing API', error);
      });
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const settlementCalculatorService = SettlementCalculatorService.instance;
